import utils from "Sources/utils/utils";
//import NavUtils from "Sources/utils/navigation-utils";
const log = require("Sources/utils/logger")();
import LanguageManager from "Sources/services/language-manager";
import HtmlTemplate from "Views/partials/materials/mission-material-category.html";
import MaterialTemplate from "Views/partials/materials/mission-material.html";

import "Styles/components/mission-material.scss";
import {isVisible} from "../../libs/bootstrap/js/src/util";
import MissionMaterial from "./mission-material";

class MissionMaterialCategory
{
  constructor(options)
  {
    this.$container = $(options.container);
    this.hasRendered = false;
    this.category = options.category;
    this.materials = options.materials;
    this.showCheckmarks = options.showCheckmarks;
    this.showMaterialAmountPicker = options.showMaterialAmountPicker;
    this.categoryOpen = false;
    this.materialObjects = [];
    this.initialState = options.selected;
  }

  get category()
  {
    return this._category;
  }

  set category(category)
  {
    this._category = category;
    this.updateCategory();
  }

  static setUpMissionMaterialCategory(options)
  {
    let instance = new MissionMaterialCategory(options);
    instance.render();
    instance.setUpMaterials(options.maxAmount);
    instance.setInitialState(instance.initialState);
    instance.setUpEventListeners();
    return instance;
  }

  setInitialState(selected)
  {
    if(selected)
    {
      this.selectAllMaterials();
      //this.updateCheckbox();
      this.updateCategory();
    }
  }

  setUpMaterials(maxAmount)
  {
    this.materialObjects = [];

    let that = this;

    //set up material elements
    this.materials.forEach(function(material){

      let container = "#materials-" + that.category.key;

      let materialObject = MissionMaterial.setUpMissionMaterial({ container: container,
        material: {
          key : material.key,
          name : material.name,
          amount: material.amount
        },
        maxAmount: maxAmount,
        selected: material.selected,
        showCheckmark: that.showCheckmarks,
        showAmount: that.showMaterialAmountPicker,
        onMaterialAmountOpened: that.onMaterialAmountOpened.bind(that),
        onMaterialSelected: that.onMaterialSelected.bind(that),
      });
      that.materialObjects.push(materialObject);
    });

    this.updateCategory();
  }

  onMaterialAmountOpened()
  {
    //close all
    this.materialObjects.forEach(material => {
      material.closeAndUpdate();
    });
  }

  onMaterialSelected()
  {
    this.updateCategory();
  }

  getMaterials()
  {
    let mats = [];
    this.materialObjects.forEach(material => {
        mats.push(material);
    });

    return mats;
  }

  getSelectedMaterials()
  {
    let selectedMaterials = [];
    this.materialObjects.forEach(material => {
      if(material.selected)
      {
        selectedMaterials.push(material);
      }
    });

    return selectedMaterials;
  }

  setUpEventListeners()
  {

    const TOGGLE_OPEN_BTN_ID = ".open-category-btn";
    const CHECKBOX_ID = ".special-checkbox";
    const HEADER_LABEL_ID = ".category-header-label";

    let that = this;
    this.$element.find(TOGGLE_OPEN_BTN_ID).on("click", function(e)
    {
      that.categoryOpenToggle();
    });

    this.$element.find(HEADER_LABEL_ID).on("click", function(e)
    {
      that.categoryOpenToggle();
    });

    this.$element.find(CHECKBOX_ID).on("click", function(e)
    {
      if(that.getSelectedMaterials().length === that.materials.length)
      {
        that.unselectAllMaterials();
      }
      else
      {
        that.selectAllMaterials();
      }
      that.updateCategory();
    });

  }

  unselectAllMaterials()
  {
    this.materialObjects.forEach(material => {
      material.setUnselected();
    });
  }

  selectAllMaterials()
  {
    this.materialObjects.forEach(material => {
      material.setSelected();
    });
  }

  categoryOpenToggle()
  {
    if(this.categoryOpen)
    {
      this.$element.find(".category-materials").show();
      this.$element.find(".open-category-btn").addClass("open");
    }
    else
    {
      this.$element.find(".category-materials").hide();
      this.$element.find(".open-category-btn").removeClass("open");
    }
    this.categoryOpen = !this.categoryOpen;
  }

  updateCheckbox()
  {

    if(this.$element)
    {
      let $checkbox = this.$element.find(".special-checkbox");
      switch(this.getSelectedMaterials().length)
      {
        case 0:
          $checkbox.removeClass("checked").removeClass("partial");
          break;

        case this.materials.length:
          $checkbox.addClass("checked").removeClass("partial");
          break;

        default:
          $checkbox.removeClass("checked").addClass("partial");
          break;
      }
    }

  }

  render()
  {
    this.hasRendered = false;
    this.$element = $(HtmlTemplate);
    this.$container.prepend(this.$element);
    LanguageManager.applyLocale(this.$element);

    this.updateCategory();
    this.hasRendered = true;
  }

  show()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.show();
    }
  }

  hide()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.hide();
    }
  }

  destroy()
  {
    if(utils.isNotNull(this.$element) && this.$element.length)
    {
      this.$element.remove();
    }
  }

  updateCategory() {
    if (utils.isNotNull(this.$element) && this.$element.length) {
      let $categoryName = this.$element.find("[data-bind-target='category-name']");
      $categoryName.empty();

      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.name)) {
        $categoryName.text(this.category.name);
      }

      let $materialCount = this.$element.find("[data-bind-target='category-material-count']");
      $materialCount.empty();
      $materialCount.text(" (" + this.getSelectedMaterials().length + "/" + this.materials.length +")" )

      let $categoryLabel = this.$element.find("[data-bind-target='category-label']");
      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.key)) {
        $categoryLabel.attr("for", this.category.key);
      }

      let $categoryCheckbox = this.$element.find("[data-bind-target='category-checkbox']");
      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.key)) {
        $categoryCheckbox.attr("id", this.category.key);
      }

      let $materialWrapper = this.$element.find("[data-bind-target='category-materials']");
      if (utils.isNotNull(this.category) && utils.isNotNull(this.category.key)) {
        $materialWrapper.attr("id", "materials-" + this.category.key);
      }
    }

    this.updateCheckbox();
  }

  updateMaterials(){
    let $materials = this.$element.find("[data-bind-target='category-materials']");
    $materials.empty();

    this.category.materials.forEach((material) => {
      let $element = $(MaterialTemplate);
      let $materialName = $element.find("[data-bind-target='material-name']");
      $materialName.text(material.name);

      $materials.append($element);
      LanguageManager.applyLocale($element);
    });
  }


  showMaterial(material) {

    this.category.materials.push(material);
    this.updateMaterials();

  }

}

export default MissionMaterialCategory;



// WEBPACK FOOTER //
// ./app/js/components/mission-material-category.js